import { BrandImage } from '../../../modules/BrandEdit';
import { countryByShortcode } from '../../../utils/country';
import { updateCmsBrandEntities } from './cmsbrands.actions';
import * as Immutable from 'seamless-immutable';
import { Action } from 'redux';
import { isType } from 'typescript-fsa/lib';
import { AppState } from '../../reducers';
import * as R from 'ramda';

export interface CmsBrand {
  id: number;
  name: string;
  slug: string | null;
  gender: string;
  images: BrandImage[];
}

export interface CmsBrands {
  [key: number]: {
    byId: {
      [key: string]: CmsBrand;
    };
  };
}

const initialState = Immutable.from<CmsBrands>({});

export type CmsBrandState = CmsBrands & Immutable.ImmutableObject<CmsBrands>;

export default function reduce(
  state: CmsBrandState = initialState,
  action: Action
) {
  if (isType(action, updateCmsBrandEntities)) {
    const {
      payload: { appId, brands },
    } = action;
    return state.merge(
      {
        [appId]: {
          byId: brands,
        },
      },
      { deep: true }
    );
  }

  return state;
}

export function getCmsBrands(state: AppState) {
  const {
    brandList: { country },
  } = state;
  const appId = countryByShortcode(country).id;

  return getBrandsByAppId(state, appId);
}

export function getBrandsByIds(
  state: AppState,
  appId: number,
  ids: number[]
): CmsBrand[] {
  const {
    entities: { cmsBrands },
  } = state;

  return (
    cmsBrands && cmsBrands[appId] && ids.map(id => cmsBrands[appId].byId[id])
  );
}

export function getBrandsByAppId(state: AppState, appId: number) {
  const {
    entities: { cmsBrands },
  } = state;

  return cmsBrands[appId] && R.values(cmsBrands[appId].byId);
}



// WEBPACK FOOTER //
// ./src/store/Entities/CmsBrands/cmsbrands.reducer.ts